import React from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Button,
    IconButton
} from "@mui/material";
import DownloadImg from "../Images/download.png";
import DeleteImg from "../Images/delete.png";

const AttachmentTable = ({ files, onPreview, onDownload, onDelete, sx, showPreview = true }) => {
    if (!files || files.length === 0) return null;

    return (
        <Table
            size="small"
            sx={{
                mt: 1,
                width: "45%",
                border: "1px solid #ddd",
                "& .MuiTableCell-root": {
                    padding: "6px 8px",
                    fontSize: "12px"
                },
                ...sx
            }}
        >
            <TableHead>
                <TableRow sx={{ bgcolor: "#E5E7EC" }}>
                    <TableCell sx={{ fontWeight: 600,  }}>Attachment</TableCell>
                    {showPreview && <TableCell sx={{ fontWeight: 600}}>View</TableCell>}
                    <TableCell sx={{ fontWeight: 600 }} align="center">
                        Action
                    </TableCell> 
                </TableRow>
            </TableHead>

            <TableBody>
                {files.map((file) => (
                    <TableRow key={file.id}>
                        <TableCell sx={{ fontWeight: 600 }}>{file.name}</TableCell>
                        {showPreview && (
                            <TableCell> 
                                {!(file.name && (file.name.toLowerCase().endsWith(".xls") || file.name.toLowerCase().endsWith(".xlsx") || file.name.toLowerCase().endsWith(".csv") || file.name.toLowerCase().endsWith(".doc") || file.name.toLowerCase().endsWith(".docx") || file.name.toLowerCase().endsWith(".txt"))) && (
                                    <Button
                                        size="small"
                                        variant="outlined"
                                        sx={{
                                            textTransform: "none",
                                            borderRadius: 1,
                                            fontSize: "10px",
                                            py: 0.5,
                                            color: "#0d6efd",
                                            backgroundColor: "white",
                                            borderColor: "#0d6efd",
                                            "&:hover": {
                                                backgroundColor: "#0d6efd",
                                                color: "white",
                                                borderColor: "#0d6efd"
                                            }
                                        }}
                                        onClick={() => onPreview && onPreview(file)}
                                        disabled={!file.url && !file.base64}
                                    >
                                        Preview
                                    </Button>
                                )}
                            </TableCell>
                        )}
                        <TableCell align="center">
                            {file.isExisting && (
                                <IconButton size="small" color="primary" onClick={() => onDownload && onDownload(file)}>
                                    <img src={DownloadImg} alt="Download" width={18} height={18} />
                                </IconButton>
                            )}
                            {onDelete && (
                                <IconButton size="small" color="error" onClick={() => onDelete(file.id, file.isExisting)}>
                                    <img src={DeleteImg} alt="Delete" width={18} height={18} />
                                </IconButton>
                            )}
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
};

export default AttachmentTable;
